import { Breadcrumb } from 'antd'
import React from 'react'
import { BackButton } from '../../../../Components/Utils/Buttons'
import RequestIndex from './Request/Index'

function MainEmployee() {
  return (
    <div className='w-full h-full px-4 py-2'>
    <div className='w-full flex justify-between items-center'>
    <Breadcrumb
      items={[
        {
          name: "Settings",
        },
        {
          name: "Employee"
        }
      ]}
    />
    <BackButton/>
    </div>
    <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto rounded-md overflow-y-scroll">
          <div className="p-3"><RequestIndex/></div>
        
    </div>
    </div>
  )
}

export default MainEmployee